module.exports = __webpack_public_path__ + "media/images/admin/icons/thumbs-up-b429fdfeed5479b1300f14e1bdabc087.svg";